import Axios from 'axios'
import { stringify } from 'qs'

// 默认配置axios实例
const Instance = Axios.create({
  baseURL: import.meta.env.DEV ? '' : window.location.origin,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
  },
  responseType: 'json',
  transformRequest: [
    data => {
      //提交前的数据处理
      return stringify(data)
    }
  ],
})

// 请求拦截器
Instance.interceptors.request.use(config => {
  return config
}, error => {
  return Promise.reject(error)
})

// 响应拦截器
Instance.interceptors.response.use(response => {
  if (
    response.data == null &&
    response.config.responseType === 'json' &&
    response.request.responseText != null
  ) {
    response.data = response.request.responseText
  }
  return response.data
}, error => {
  return Promise.reject(error)
})

export default Instance
